import * as React from 'react';
// Import react.
import { useParams } from "react-router-dom";
// Import props.
import {
	PostalCodeProps,
} from '@app/props';
// Import hooks.
import {
	useAppRedirect,
	UseAppRedirectParameters,
} from '@app/hooks/utility';

type UsePostalCodePropsFromRouterParameters = UseAppRedirectParameters;

type UsePostalCodePropsFromRouterResult = PostalCodeProps;

const usePostalCodePropsFromRouter = (params?: UsePostalCodePropsFromRouterParameters): UsePostalCodePropsFromRouterResult => {
	const { redirect } = useAppRedirect(params);
	const routeParams = useParams();

	// Parse out the router parameters for postal code.
	const postalCode: string | undefined = React.useMemo(() => {
		return routeParams['postalCode'] ?? undefined;
	}, [routeParams]);

	// State variables.
	const [isReady, setIsReady] = React.useState<boolean>(false);

	React.useEffect(() => {
		if (isReady && String.isNullOrWhiteSpace(postalCode)) {
			redirect();
		}

		if (!isReady) {
			setIsReady(() => true);
		}
	}, [postalCode]);

	return {
		postalCode: postalCode ?? String.empty(),
	}
}

// Export parameters.
export {
	UsePostalCodePropsFromRouterParameters,
};

// Export results.
export {
	UsePostalCodePropsFromRouterResult,
}

export default usePostalCodePropsFromRouter;